<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-form-item
        label="名称"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.title"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        label="链接"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.url"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        label="图片"
        style="margin-right:15px"
      >
        <img
          v-if="form.img"
          :src="form.img"
          class="el-upload-list__item-thumbnail"
          width="100%"
          height="100%"
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'PartnerShipsDetail',
  data() {
    return {
      dicts: { previewType: {}},
      emptyForm: {},
      form: {
        url: '',
        title: '',
        img: ''
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/partnerShips/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
